module.exports = __webpack_public_path__ + "img/benefits-18.81302120.svg";